import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { BuildingFilledIcon } from '@gemini/icons';
import { Avatar } from '@gemini/ui';
const Logo = ({ linkUrl, agencyLogo, agencyName, onClick }) => {
    return (_jsx(Box, { "aria-label": "agency-profile-url", as: "a", color: "color.content.disabled", cursor: linkUrl ? 'pointer' : 'default', href: linkUrl, target: "_blank", onClick: onClick, children: _jsx(Avatar, { icon: !agencyLogo ? BuildingFilledIcon : undefined, imageFit: "contain", imageUrl: agencyLogo ?? undefined, initials: agencyName, label: "Avatar", size: "56" }) }));
};
export default Logo;
